<template>
<div class="columns floating-date">
    <b-icon icon="alpha-x-circle" size="is-medium" class="close-student" @click.native="closeAdvisor()"></b-icon>
    <b-datepicker class="column is-full" inline v-model="date" @mouseover.native="showDate" :events="events" indicators="bars">
        <b v-if="timeSpentInDay !== 0">
            {{ timeSpentInDay }}
        </b>
    </b-datepicker>

    <b-field class="column is-full" label="Number of hours below which it shows red">
        <b-input v-model="numberOfHours" type="number" @input="setUserTimeSpent"></b-input>
    </b-field>
</div>
</template>

<script>
export default {
    name: 'TimeChart',
    props: ['selectedUserTime'],
    data() {
        return {
            date: new Date(),
            timeSpentInDay: 0,
            events: [new Date()],
            numberOfHours: 4
        }
    },
    created() {
        if (this.selectedUserTime.length) {
            this.setUserTimeSpent()
        }

    },
    methods: {
        setUserTimeSpent() {
            const events = this.selectedUserTime.map((day) => {
                const formatedTimeSpent = this.msToTime(day.time)
                return {
                    date: new Date(day.published_date),
                    timeSpent: formatedTimeSpent,
                    type: this.getTimeWarning(day.time, formatedTimeSpent)
                }
            })

            this.events = events
        },

        msToTime(ms) {
            let seconds = (ms / 1000).toFixed(1);
            let minutes = (ms / (1000 * 60)).toFixed(1);
            let hours = (ms / (1000 * 60 * 60)).toFixed(1);
            let days = (ms / (1000 * 60 * 60 * 24)).toFixed(1);
            if (seconds < 60) return seconds + " Sec";
            else if (minutes < 60) return minutes + " Min";
            else if (hours < 24) return hours + " Hrs";
            else return days + " Days"
        },

        showDate(event) {
            const hasEventClass = event.srcElement.getElementsByClassName('event')
            if (hasEventClass.length && hasEventClass.length === 1) {
                this.timeSpentInDay = hasEventClass[0].className.replace('is-danger', '').replace('event', '').replace('is-success', '')
            }
        },

        getTimeWarning(ms, formatedDate) {
            return (ms / (1000 * 60 * 60)).toFixed(1) < this.numberOfHours ? `is-danger ${formatedDate}` : `is-success ${formatedDate}`
        },

        closeAdvisor() {
            this.$emit('closeAdvisor')
        }
    },
    computed: {
        thisMonth() {
            return new Date().getMonth()
        }
    }
}
</script>

<style>
    .floating-date {
        position: fixed;
        top: 90px;
        background: white;
        right: 0;
        z-index: 100;
        max-width: 400px;
    }

    .close-student {
        position: absolute;
        z-index: 101;
        right: 13px;
        cursor: pointer;
    }
</style>
